import React from "react";
import { FileText, Gavel, Presentation, Bookmark, X, Pencil } from "lucide-react";
import { INVOICE_TEMPLATES } from "@/lib/templates";

const ICONS = { gutachten: Gavel, fortbildung: Presentation };

const Tile = ({ k, label, active, onPick, onDelete, onEdit, Icon }) => (
  <div className="relative group">
    <button
      type="button"
      onClick={() => onPick(k)}
      data-testid={`template-${k || "blank"}`}
      className={`w-full flex items-center gap-2.5 pl-3.5 ${onDelete ? "pr-16" : "pr-8"} py-3 rounded-xl border text-sm font-medium text-left transition-colors ${
        active ? "border-blue-600 bg-blue-50 text-blue-700" : "border-slate-200 text-slate-700 hover:bg-slate-50"
      }`}
    >
      <Icon className="h-4 w-4 shrink-0" /> <span className="truncate">{label}</span>
    </button>
    {onEdit && (
      <button
        type="button"
        onClick={onEdit}
        title="Vorlage bearbeiten"
        data-testid={`edit-template-${k}`}
        className="absolute right-9 top-1/2 -translate-y-1/2 h-6 w-6 grid place-items-center rounded-md text-slate-400 hover:text-blue-700 hover:bg-blue-50"
      >
        <Pencil className="h-3.5 w-3.5" />
      </button>
    )}
    {onDelete && (
      <button
        type="button"
        onClick={onDelete}
        title="Vorlage löschen"
        data-testid={`delete-template-${k}`}
        className="absolute right-2 top-1/2 -translate-y-1/2 h-6 w-6 grid place-items-center rounded-md text-slate-400 hover:text-red-600 hover:bg-red-50"
      >
        <X className="h-3.5 w-3.5" />
      </button>
    )}
  </div>
);

export const TemplatePicker = ({ active, onPick, custom = [], onDelete, onEdit }) => (
  <div className="bg-white border border-slate-200/80 rounded-2xl p-6" data-testid="template-picker">
    <h3 className="font-display font-semibold text-base mb-1">Vorlage</h3>
    <p className="text-sm text-slate-500 mb-4">Positionen werden vorausgefüllt – Mengen und Beträge können Sie anpassen.</p>
    <div className="grid grid-cols-1 sm:grid-cols-3 gap-2">
      {[{ key: "", label: "Leere Rechnung" }, ...INVOICE_TEMPLATES].map((t) => (
        <Tile key={t.key || "blank"} k={t.key} label={t.label} active={(active || "") === t.key} onPick={onPick} Icon={ICONS[t.key] || FileText} />
      ))}
    </div>
    {custom.length > 0 && (
      <>
        <p className="text-xs font-medium text-slate-500 mt-5 mb-2">Meine Vorlagen</p>
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-2" data-testid="custom-templates">
          {custom.map((t) => (
            <Tile key={t.id} k={`c:${t.id}`} label={t.name} active={active === `c:${t.id}`} onPick={onPick} Icon={Bookmark} onDelete={() => onDelete(t)} onEdit={() => onEdit(t)} />
          ))}
        </div>
      </>
    )}
  </div>
);
